import * as Sentry from "@sentry/nextjs";
import { useRouter } from "next/router";
import type { ComponentType } from "react";
import type { FallbackProps } from "react-error-boundary";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import { ApplicationError, RedirectError } from "~/lib/error";
import { trpc } from "~/lib/trpc";

import { DefaultErrorFallback } from "./DefaultErrorFallback";

export function ErrorBoundary({
  children,
  FallbackComponent = DefaultErrorFallback,
}: {
  children?: React.ReactNode;
  FallbackComponent?: ComponentType<FallbackProps>;
}) {
  const router = useRouter();

  const trpcContext = trpc.useContext();
  async function handleReset() {
    await trpcContext.invalidate();
  }

  async function handleError(error: Error) {
    if (error instanceof RedirectError) {
      return;
    }

    console.error(error);
    Sentry.captureException(error);
  }

  return (
    <ReactErrorBoundary
      FallbackComponent={FallbackComponent}
      resetKeys={[router.asPath]}
      onReset={handleReset}
      onError={handleError}>
      {children}
    </ReactErrorBoundary>
  );
}
